// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"labFlag_wrapper__1Zu-W","h":"labFlag_h___jdC7","l":"labFlag_l__sG8Oa","n":"labFlag_n__2_8gQ"};